import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import {StorageService} from '../../../../Services/storage.service';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ReportPrintService} from '../../../../Services/report-print.service';
import {SendEmailModalComponent} from '../../../common/send-email-modal/send-email-modal.component';
import {EmailModel} from '../../../../DataModels/email-model';
import {Modal} from 'bootstrap';

export interface CrmPipelineAgingRow {
  opportunity_id: string;
  title: string;
  entity_name: string;
  salesperson_id: string;
  stage_name: string;
  estimated_value: number;
  probability: number;
  expected_close_date: string;
  created_date: string;
  days_in_pipeline: number;
  days_overdue: number | null;
}

@Component({
  selector: 'app-crm-pipeline-aging-report',
  templateUrl: './crm-pipeline-aging-report.component.html',
  styleUrls: [],
  standalone: false,
})
export class CrmPipelineAgingReportComponent implements OnInit {

  @ViewChild('ReportOutput', {static: false}) ReportOutput: ElementRef;
  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private localSendEmailModalHost: ElementRef;

  rptName = 'Pipeline Aging Report';
  isLoading = false;
  noDataFound = false;
  rows: CrmPipelineAgingRow[] = [];
  users: any[] = [];
  stages: any[] = [];
  reportDataToSendInEmail: EmailModel = new EmailModel();

  buttonConfig: any = {
    print: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: false,
    close: true,
    clear: false,
    filters: false,
    reset: true,
  };

  filters: any = {
    company_id: '',
    salesperson_id: '',
    stage_id: '',
  };

  vm: any = {Preferences: []};

  constructor(
    private titleService: Title,
    private router: Router,
    private tableDataService: DataService,
    private localStorage: StorageService,
    private notification: BsToastService,
    private reportPrint: ReportPrintService,
    private cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle(this.rptName);
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.filters.company_id = this.vm.Preferences?.defaults?.company_id ?? '';

    this.tableDataService.getApiListData('sys_user', '?pageNumber=0&pageSize=999').subscribe({
      next: (result: any) => {
        this.users = result.Data ?? result.items ?? [];
      },
    });

    this.tableDataService.getDataWithParams('crm_pipeline_stage', 'pageNumber=0&pageSize=999').subscribe({
      next: (result: any) => {
        this.stages = Array.isArray(result) ? result : (result.Data ?? result.items ?? []);
      },
    });
  }

  getUserName(userId: string): string {
    if (!userId) {
      return '—';
    }
    const u = this.users.find(x => x.id === userId);
    return u ? u.name : userId;
  }

  overdueClass(days: number | null): string {
    if (days == null) {
      return 'text-success';
    }
    if (days > 30) {
      return 'text-danger fw-bold';
    }
    if (days > 0) {
      return 'text-warning fw-bold';
    }
    return 'text-success';
  }

  resetFilters() {
    this.filters = {
      company_id: this.vm.Preferences?.defaults?.company_id ?? '',
      salesperson_id: '',
      stage_id: '',
    };
    this.rows = [];
    this.vm.report = null;
  }

  close() {
    this.router.navigate(['/home']);
  }

  runReport() {
    this.isLoading = true;
    this.noDataFound = false;
    this.rows = [];

    let params = 'company_id=' + (this.filters.company_id || '');
    if (this.filters.salesperson_id) {
      params += '&salesperson_id=' + this.filters.salesperson_id;
    }
    if (this.filters.stage_id) {
      params += '&stage_id=' + this.filters.stage_id;
    }

    this.tableDataService.getDataWithParams('CrmPipelineAgingReport', params).subscribe({
      next: (result: any) => {
        this.rows = Array.isArray(result) ? result : (result.Data ?? result.items ?? []);
        this.noDataFound = this.rows.length === 0;
        this.vm.report = this.rows;
        this.isLoading = false;
      },
      error: (err) => {
        console.error(err);
        this.notification.showErrorToast('Error loading report.');
        this.isLoading = false;
      },
    });
  }

  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.reportPrint.printInIframe(html);
    } catch (e) {
      console.error('CRM Pipeline Aging Report print failed', e);
    }
  }

  setEmailData() {
    const emailDocObj = {} as EmailModel;
    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';
    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '';
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + this.rptName + '.<br><br>Best regards,<br><br>AcctXErp<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + this.rptName;
    try {
      this.cd.detectChanges();
    } catch {
    }
    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      emailDocObj.pdfHtml = this.ReportOutput?.nativeElement?.outerHTML || '';
    }
    emailDocObj.activity_message = this.rptName;
    const now = new Date();
    emailDocObj.FileName = `CrmPipelineAgingReport_${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}.pdf`;
    this.reportDataToSendInEmail = emailDocObj;
    const element = document.getElementById('sendEmailModal') as HTMLElement;
    if (element) {
      const emailModal = new Modal(element);
      emailModal.show();
    }
  }

  private buildPrintHtml(forEmail: boolean = false): string {
    const rawContent = (this.ReportOutput?.nativeElement?.outerHTML || '').toString();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    const meta: { label: string; value: string }[] = [];
    return this.reportPrint.buildHtml({title: this.rptName, contentHtml: content, meta, orientation: 'landscape'});
  }
}
